module.exports = __webpack_public_path__ + "img/playerAnalysis.dfa9e998.svg";